<template>
  <div>
    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>
    <div class="selectdiv mb-4" :disabled="!ifTeamleaderAnchorPermission">
      <div class="row">
        <div class="col-4">
          <div class="search-container">
            <tl-search @change="filterData($event)" :placeholder="'Search Employee Name'" />
          </div>
        </div>
        <div class="col-4">
          <!-- <span class="show-filter-block" @click="showFilter = !showFilter">
            <img class="search-icon-filter" src="@/assets/filter.png" alt="" />
            <span class="filter-text">Show Filter</span>
          </span> -->
        </div>
        <div class="col-4">
          <div class="float-right">
            <!-- <a class="anchor-underline-none download-block" href="#">
              <span class="mx-5">
                <img
                  class="search-icon-filter"
                  src="@/assets/logout-copy-3.svg"
                  style="width: 30px; height: 34px;"
                  alt=""
                />
                <span class="filter-text">Download </span>
              </span>
            </a> -->
            <div class="grid-list-block">
              <img
                class="search-icon-filter"
                src="@/assets/emp-dir-list.svg"
                v-on:click="seen = false"
                alt=""
              /><span class="line"></span
              ><img
                class="search-icon-filter"
                src="@/assets/emp-dir-grid.svg"
                v-on:click="seen = true"
                alt=""
              />
            </div>
          </div>
          <!-- <div class="select-width">
            <select
              class="form-control select-left"
              @change="changeMonthTitle($event)"
            >
              <option value="" selected disabled>Choose</option>
              <option
                v-for="monthTitle in monthFrom"
                :value="monthTitle.id"
                :key="monthTitle.id"
              >
                {{ monthTitle.name }}
              </option>
            </select>
            <select
              class="form-control select-right"
              @change="changeMonthTitle($event)"
            >
              <option value="" selected disabled>Choose</option>
              <option
                v-for="monthTitle in monthTo"
                :value="monthTitle.id"
                :key="monthTitle.id"
              >
                {{ monthTitle.name }}
              </option>
            </select>
          </div> -->
        </div>
      </div>
    </div>

    <!-- Filter code -->
    <div class="filter-block" v-if="showFilter">
      <div class="col-3padding-l-n">
        <tl-select
          label="Paygroup"
          labelText="name"
          v-model="paygroup"
          :multiple="true"
          :options="paygroupOptions"
          @change="(val)=>paygroup = val"
        />
      </div>
      <div class="col-3">
        <tl-select
          label="Criteria"
          v-model="criteria"
          :options="criteriaOptions"
          @change="(val) => {criteria = val;onSelectCriteria(val)}"
        />
      </div>
      <div class="col-3" v-if="subCriteriaLabel">
        <tl-select
          :label="subCriteriaLabel"
          labelText="name"
          v-model="subcriteria"
          :multiple="true"
          :options="subCriteriaList"
          @change="(val)=>subcriteria = val"
        />
      </div>
      <div class="col-3" v-if="subCriteriaLabel">
        <btn text="Apply Filters" type="secondary" class="btn-filter" @click="applyFilter"></btn>
      </div>
    </div>
    <!-- End Filter code -->

    <div class="grid-list" v-if="seen" :disabled="!ifTeamleaderAnchorPermission">
      <div
        class="employee mb-3"
        v-for="(item, index) in existEmployeeList"
        :key="index"
        v-on:click="onSelectItem(item)"
      >
        <div class="employee-img">
          <div class="imgDetails">
            <img
              :src="item[0][0]['photo_url']"
              class="userImg"
              alt=""
              v-if="item[0][0]['photo_url']"
            />
            <img
              src="@/assets/user.svg"
              class="userImg"
              alt=""
              v-if="!item[0][0]['photo_url']"
            />
            <div class="text-center">
              <p class="empId my-2">
                <strong>{{
                  item[0][0]["code"] ? item[0][0]["code"] : "-"
                }}</strong>
              </p>
              <div>
                <span class="empName"
                  >{{ item[0][0]["first_name"] }}
                  {{ item[0][0]["last_name"] }}</span
                ><br />
                <div class="empDetails">
                  {{ item[0]["designation"] ? item[0]["designation"] : "-" }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="employee-details">
          <div class="details">
            <div>
              <img src="@/assets/phone-call.svg" alt="" />{{
                item[0][0]["mobile_number"] ? item[0][0]["mobile_number"] : "-"
              }}
            </div>
            <div>
              <img src="@/assets/mail.svg" alt="" />{{
                item[0][0]["email_id"] ? item[0][0]["email_id"] : "-"
              }}
            </div>
            <div>
              <img src="@/assets/placeholder.svg" alt="" />{{
                item[0]["jobLocation"] ? item[0]["jobLocation"] : "-"
              }}
            </div>
            <br />
            <div>
              Reports to <br />
              <strong>{{
                item[0]["reportingManager"] ? item[0]["reportingManager"] : "-"
              }}</strong>
            </div>
            <br />

            <div>
              <div>
                Last working date <br />
                <strong>{{
                  item[0][0].EmployeeFnf.last_working_date
                  ? formatDate(item[0][0].EmployeeFnf.last_working_date)
                  : "-"
                }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid-list" v-else :disabled="!ifTeamleaderAnchorPermission">
      <data-table
        :columns="employeeTableColumns"
        :tableData="existEmployeeList"
        :checkbox="false"
        :withForm="false"
        :showinrow="false"
        :clickAllowed="true"
        @selectedItem="onSelectItem"
        @download="downloadItem"
        @delete="deleteItem"
        @editStart="initEditStart"
        @update="updateItem"
        @deselected="deselectItem"
        id="empTable"
      >
        <template v-slot:rowcontent="slotprops">
          <img
            class="user-img"
            v-if="
              slotprops.value.column.key === 'photo_url' &&
              slotprops.value.record[0][0][slotprops.value.column.key]
            "
            :src="slotprops.value.record[0][0][slotprops.value.column.key]"
            alt=""
          />
          <img
            class="user-img"
            v-if="
              slotprops.value.column.key === 'photo_url' &&
              !slotprops.value.record[0][0][slotprops.value.column.key]
            "
            src="@/assets/user.svg"
            alt=""
          />
          <p v-if="slotprops.value.column.key === 'name'">
            {{ slotprops.value.record[0][0]["first_name"] }}
            {{ slotprops.value.record[0][0]["last_name"] }}
          </p>
          <p v-if="slotprops.value.column.key !== 'photo_url'">
            {{ slotprops.value.record[0][0][slotprops.value.column.key] }}
          </p>
          <p
            v-if="
              slotprops.value.column.key === 'reportingManager' ||
              slotprops.value.column.key === 'designation' ||
              slotprops.value.column.key === 'jobLocation'
            "
          >
            {{ slotprops.value.record[0][slotprops.value.column.key] }}
          </p>
        </template>
      </data-table>
    </div>

    <div v-if="showModal">
      <div class="modal custom-modal">
        <div class="modal-content modal-sm modal-border-radius">
          <div class="modal-emp-header">
            <img
              src="@/assets/close.png"
              class="close-img"
              v-on:click="showModal = false"
              alt=""
            />

            <div class="row">
              <div class="col-12 text-center">
                <img
                  src="@/assets/user.svg"
                  class="modal-user-img"
                  alt=""
                  v-if="!modalRecord[0][0]['photo_url']"
                /><img
                  :src="modalRecord[0][0]['photo_url']"
                  class="modal-user-img"
                  alt=""
                  v-if="modalRecord[0][0]['photo_url']"
                /><br />
                <span class="modal-emp-name">{{ modalRecord[0][0]["first_name"] }} {{ modalRecord[0][0]["last_name"] }}</span
                ><br />
                <span class="modal-emp-code"
                  >Employee Code: <strong> {{ modalRecord[0][0]["code"] }} </strong></span
                >
              </div>
            </div>
          </div>
          <div class="modal-body mx-2 my-2">
            <table>
              <tr>
                <td class="width-left-data">Designation :</td>
                <td class="width-right-data">
                  {{ modalRecord[0]["designation"] }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Department :</td>
                <td class="width-right-data">
                  {{ modalRecord[0]["department"] }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Job Location :</td>
                <td class="width-right-data">
                  {{ modalRecord[0]["jobLocation"] }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Email :</td>
                <td class="width-right-data">
                  {{ modalRecord[0][0]["email_id"] }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Reporting Manager :</td>
                <td class="width-right-data">
                  {{ modalRecord[0]["reportingManager"] }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">DOJ :</td>
                <td class="width-right-data">
                  {{ formatDate(modalRecord[0]["date_of_joining"]) }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Resignation date :</td>
                <td class="width-right-data">
                  {{ formatDate(modalRecord[0][0].EmployeeFnf.initiation_date) }}
              </td>
              </tr>
               <tr>
                <td class="width-left-data">Last working date :</td>
                <td class="width-right-data">
                  {{ formatDate(modalRecord[0][0].EmployeeFnf.last_working_date) }}
              </td>
              </tr>
              <tr>
                <td class="width-left-data">Emergency Contact name :</td>
                <td class="width-right-data">
                  {{ modalRecord[0][0]["emergency_contact_name"] }}
                </td>
              </tr>
              <tr>
                <td class="width-left-data">Emergency Contact :</td>
                <td class="width-right-data">
                  {{ modalRecord[0][0]["emergency_contact_number"] }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "exits",
  props: {
    existEmployeeList: {
      type: Array,
    },
    tableData: {
      type: Array,
    }
  },
  data() {
    return {
      employeeTableColumns: [
        {
          label: "",
          key: "photo_url",
        },
        {
          label: "Code",
          key: "code",
        },
        {
          label: "Name",
          key: "name",
        },
        {
          label: "Email",
          key: "email_id",
        },
        {
          label: "Reporting To",
          key: "reportingManager",
        },
        {
          label: "Designation",
          key: "designation",
        },
        {
          label: "Location",
          key: "jobLocation",
        },
      ],
      seen: true,
      showModal: false,
      modalRecord: null,
      employeeData: [],
      items: [],
      monthFrom: [
        { name: "2016-2017", id: 1 },
        { name: "2017-2018", id: 2 },
        { name: "2018-2019", id: 3 },
        { name: "2019-2020", id: 4 },
      ],
      monthTo: [
        { name: "All Months", id: 1 },
        { name: "2017-2018", id: 2 },
        { name: "2018-2019", id: 3 },
        { name: "2019-2020", id: 4 },
      ],
      showFilter: false,

      // Add new data
      paygroup: "",
      subcriteria: [],
      paygroupOptions: [],
      criteria: "",
      criteriaOptions: [
        "Band",
        "Cost Centre",
        "Business Unit",
        "Grade",
        "Location"
      ],
      subCriteriaList: [],
      subCriteriaLabel: "",
      empId: "",
      month: "",
      monthsList: [
        { name: "January", value: "jan" },
        { name: "February", value: "feb" },
        { name: "March", value: "mar" },
        { name: "April", value: "apr" },
        { name: "May", value: "may" },
        { name: "June", value: "jun" },
        { name: "July", value: "jul" },
        { name: "August", value: "aug" },
        { name: "September", value: "sep" },
        { name: "October", value: "oct" },
        { name: "November", value: "nov" },
        { name: "December", value: "dec" }
      ],
      lopData: [],
      companyValue: false,
      role: ""
      
    };
  },
  created() {
    this.lopData = [...this.existEmployeeList];
  },
  activated() {
    let d = new Date();
    this.month = this.monthsList[d.getMonth()];
    this.getPaygroups();
    this.lopData = [...this.existEmployeeList];
    //console.log(this.tableData)
    // this.fetchAllEmployeesLOPRLOP();
    this.getOrgLeIdList();
  },
  mounted() {
    let d = new Date();
    this.month = this.monthsList[d.getMonth()];
    this.getPaygroups();
    this.lopData = [...this.existEmployeeList];
    //console.log(this.tableData);
    this.getOrgLeIdList();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ...mapState({
      lopRlopData: state => state.dashboard.payroll.utilities.lopsandrlop
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ifTeamleaderAnchorPermission() {
      if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
        if(this.companyValue) {
          return true;
        } else {
          return false;
        }
      } 
      // else {
      //   return true 
      // }
    }
  },
  methods: {
    ...mapActions({
      fetchEmployeeByName: "globalapi/globalemployees/fetchByName",
      fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",

      // Add new mapActions
      act_create: "dashboard/payroll/utilities/uploadloprlop/create",
      act_fetch: "dashboard/payroll/utilities/uploadloprlop/fetchAll",
      act_fetchlop: "dashboard/payroll/utilities/uploadloprlop/fetchLOPsByEmp",
      //fetchEmployeeByName: "globalapi/globalemployees/fetchByName",
      //fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
      fetch_paygroups: "onboard/paygroup/fetchAll",
      fetch_locations: "onboard/locations/fetchAll",
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_businessunits: "onboard/business_units/fetchAll",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll"
    }),

    //Add new methods

    /* server call to get employee list with lop and rlop data */
    async fetchAllEmployeesLOPRLOP() {
      try {
        let res = await this.act_fetch({
          le_id: this.le_id,
          month: this.month.value,
          financial_year:
            new Date().getMonth() > 3
              ? new Date().getFullYear().toString()
              : (new Date().getFullYear() - 1).toString()
        });
        if (res.data.status) {
          this.lopData = res.data.payload;
          this.tableData = res.data.payload;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get employees after selecting filter options */
    async applyFilter() {
      try {
        let obj = {
          le_id: this.le_id,
          month: this.month.value,
          financial_year:
            new Date().getMonth() > 3
              ? new Date().getFullYear().toString()
              : (new Date().getFullYear() - 1).toString(),
          bands:
            this.criteria == "Band"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          bunits:
            this.criteria == "Business Unit"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          cost_centers:
            this.criteria == "Cost Centre"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          locs:
            this.criteria == "Location"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          paygroups: this.paygroup.length
            ? this.paygroup.map(item => {
                return item.id;
              })
            : []
        };
        let res = await this.act_fetch(obj);
        if (res.data.status) {
          // this.lopData = res.data.payload;
          // this.tableData = res.data.payload;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to search in local by name */
    filterData(val) {
      try {
        let tempArray = [];
        //console.log(this.tableData)
        this.tableData.forEach(element => {
          if (element[0][0]['first_name']) {
            if (element[0][0]['first_name'].toUpperCase().indexOf(val.toUpperCase()) > -1) {
              tempArray.push(element);
            }
          }
        });
        if (val) {
          this.existEmployeeList = tempArray;
        } else {
          this.existEmployeeList = this.tableData;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get subcriteria after changing criteria */
    onSelectCriteria(event) {
      try {
        this.subcriteria = [];
        if (event == "Location") {
          this.subCriteriaLabel = "Location";
          this.getLocations();
        } else if (event == "Cost Centre") {
          this.subCriteriaLabel = "Cost Centre";
          this.getCostCenter();
        } else if (event == "Band") {
          this.subCriteriaLabel = "Band";
          this.getBands();
        } else if (event == "Grade") {
          this.subCriteriaLabel = "Grade";
          this.getGrades();
        } else if (event == "Business Unit") {
          this.subCriteriaLabel = "Business Unit";
          this.getBU();
        } else {
          this.subCriteriaLabel = "Sub Criteria";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Locations */
    async getLocations() {
      try {
        let res = await this.fetch_locations(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Salary Bands */
    async getBands() {
      try {
        let res = await this.fetch_bands(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Paygroups */
    async getPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.le_id);
        if (res.data.status) {
          this.paygroupOptions = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Business Units */
    async getBU() {
      try {
        let res = await this.fetch_businessunits(this.orgId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get cost centre */
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get salary grades */
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    //End here

    /* server call to get employee searching by name */
    async searchEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByLeAndName({
          le_id: this.leId,
          key: val,
        });
        this.employeeData = res.data.payload;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    onSelectItem(record) {
      this.modalRecord = record;
      this.showModal = true;
      //console.log(record);
    },

    formatDate(date) {
      var myDate = new Date(date);
      var month = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ][myDate.getMonth()];
      var str = myDate.getDate() + " " + month + " " + myDate.getFullYear();
      return str;
    },
    //   changeMonthTitle (event) {
    //     this.selectedMonthTitle = event.target.options[event.target.options.selectedIndex].text
    //   }

    ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.companyValue = data.data.user.permissions.company ? true : false;
      //console.log("PL-3406",data);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";

// Filter css
.filters[data-v-c4a17984] {
  width: auto;
  height: auto;
  display: grid;
}
// End here


.nav {
  color: #555555;
  font-size: 11px;
  margin-left: 10px;
}
.grid-title {
  display: grid;
  grid-template-columns: 4fr 4fr 4fr 4fr 4fr;
  grid-template-rows: 2fr;
  grid-gap: 4px;
  padding: 10px;
  color: #646464;
  font-size: 16px;

  b {
    font-size: 24px;
  }
}
.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.3);
}

.modal-content-history {
  background-color: white;
  margin: 60px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 375px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 30px 36px 36px 0px;

  .datatableClass {
    margin-left: 10%;
    margin-top: 5%;
    overflow-y: scroll;
  }
}
.top-bar {
  background-color: #34c0be;
  display: flex;
  width: 108%;
  height: 85px;
  margin-top: -30px;
}
.heading_new {
  font-family: Montserrat;
  font-size: 22px;
  font-weight: bold;
  padding: 10px;
  color: #ffffff;
}
.imagearea {
  display: flex;

  img {
    padding: 10px;
    margin-left: 5%;
    width: 90px;
    height: 90px;
  }
}
.emp-header {
  padding: 20px 0px 0px 10px;
  display: flex;
  .text {
    font-size: 16px;
    color: #646464;
    margin-right: 10px;
  }

  .line {
    border-bottom: 1px solid #34c0be;
    flex-grow: 1;
  }
}

.filters-section {
  display: flex;
  align-items: flex-end;
  margin-top: 30px;
  margin-left: 10px;
  // overflow: scroll;
  *:nth-child(1) {
    margin-right: 10px;
  }
}

.selectdiv {
  select {
    max-width: 200px;
    border-radius: 4px;
    outline: 0;
    font-size: 14px;
    color: #9c9c9c;
    border: 1px solid #dadada;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    /* SVG background image */
    // background: url("@/assets/stroke-1.png");
    background-size: 12px;
    background-position: calc(100% - 10px) center;
    background-repeat: no-repeat;

    option {
      color: #9c9c9c;
      font-size: 12px;
    }
  }
  span {
    color: #b3b3b3;
    font-size: 12px;
  }
}
.filters-button {
  margin-top: 10px;
  width: 95px;
  height: 35px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 4px;
  color: #555555;
  border: 1px solid #37c6c0;
}
.search-bar {
  padding: 30px 0px 0px 10px;
  display: flex;
}
.addnewempbtn {
  width: 130%;
  display: flex;
  justify-content: center;
  height: 30px;
  background-color: #5d409f;
  border: #5d409f solid 1px;
  color: #ffffff;
  margin-left: 10px;
  border-radius: 4px;
  align-items: center;
  *:nth-child(n) {
    margin-right: 5px;
  }
}
.export-section {
  margin-left: 6%;
  margin-top: -8px;
  align-items: center;
  display: flex;
}
.export-button {
  width: 70px;
  height: 25px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
  margin-left: 3px;
}
.sort-by {
  display: flex;
  margin-left: 7%;

  span {
    margin-right: 10px;
    margin-top: 10px;
    color: #b3b3b3;
    font-size: 12px;
  }
}
.side-actions {
  margin-left: 10px;
  margin-top: 10px;
  img {
    cursor: pointer;
    margin-right: 5px;
    margin-left: 5px;
  }
}
.ver-line {
  border-right: solid 1px #30b6bc;
  padding-top: 10px;
}
.employee-cards {
  padding: 30px 0 0 10px;
}
.btnGrp {
  margin-left: 33px;
}
.align-filters {
  display: flex;
  margin: 30px 0 0 10px;
  *:nth-child(1) {
    text-align: center;
  }
  button {
    // margin: 30px 0 0 10px;
    // width: 120px;
    // height: 28px;
    // display: flex;
    border-radius: 100px;
    background-color: #b2f8f7;

    // span {
    //   margin-left: 10px;
    // }
    // img {
    //   margin-left: 56%;
    //   margin-top: 3px;
    // }
  }
}
.filters {
  width: 125px;
  height: 28px;
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
  *:nth-child(1) {
    margin-right: 10px;
    padding-left: 5px;
  }
  img {
    margin-top: 3px;
    margin-right: 10px;
    cursor: pointer;
  }
}
.save-tags {
  margin-left: 10px;
  span {
    font-size: 12px;
    cursor: pointer;
  }
}
.btn-popup {
  display: block;
  border-radius: 4px;
  height: 35px;
  width: 120px;
  align-self: center;
  background-color: #5d409f;
  color: #ffffff;
}
.clear-filters {
  font-size: 12px;
  margin-top: 7px;
  margin-left: 19px;
  cursor: pointer;
}
.alignCss {
  padding: 28px;
  margin-bottom: 100px;
}

.card-container {
  width: 100%;
}
.employee {
  width: 32%;
  height: 210px;
  border-radius: 10px;
  border: solid 1px #f2f2f2;
  display: inline-flex;
  background-color: #ffffff;
  margin: 0px 10px 10px 0px;
  cursor: pointer;
}
.employee-img {
  position: relative;
  width: 51%;
  border-right: 1px solid #f2f2f2;
  // opacity: 0.11;
  padding: 18px; // 10px
  height: 100%;
}
.imgDetails {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .link-actions {
    margin-left: 10px;
    display: flex;
    justify-content: space-between;
  }
}
.action-container {
  right: 15px;
  position: absolute;
  display: flex;
  // flex-direction: column;
  img {
    cursor: pointer;
  }
}
.action {
  width: 4px;
  height: 4px;
  margin: 4px;
  color: #000000;
}
.employee-details {
  width: 60%;
  padding: 18px; //12px
  position: relative;
}
.checkbox {
  position: absolute;
  height: 18px;
  width: 18px;
  border-radius: 4px;
  border: 1px solid #f2f2f2;
  background-color: #ffffff;
}
.empId {
  color: #878787;
  font-size: 12px;
  text-align: center;
}
.empName {
  font-family: Montserrat;
  font-size: 14px;
  color: #979797;
  // margin-left: 13px;
  color: #646464;
  font-weight: 500;
  text-transform: capitalize;
}
.empDetails {
  font-family: Montserrat;
  font-size: 12px;
  color: #979797;
  text-align: center;
  text-transform: capitalize;
  // margin-left: 30px;
}
.details {
  font-family: Montserrat;
  font-size: 12px;
  color: #878787;
  img {
    width: 10px;
    height: 10px;
    margin-right: 5px;
  }
}
.link-actions {
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  img {
    width: 13px;
    height: 13px;
  }
}
button {
  margin-top: 10px;
  width: 75px;
  height: 20px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 4px;
  color: #555555;
  border: 1px solid #37c6c0;
}
.joining-time {
  color: #5d409f;
  font-size: 12px;
  margin-top: 10px;
}
.offer-status {
  color: #5d409f;
  font-size: 12px;
  cursor: pointer;
}

.action-container-icon {
  margin-left: 98%;
}
.action-menu {
  width: 128px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.23);
  background-color: #ffffff;
  margin-right: 10px;
  border-right: 20px solid #ffffff;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;

  .edit {
    cursor: pointer;
    // margin-left: 5px;
    font-size: 12px;
    padding: 5px 0px 5px 5px;
    color: #616363;
    width: 120px;
    // text-align: center;

    &:hover {
      border: 1px solid #c0edeb;
      // width: 120px;
      // height: 20px;
      // color:red;
      background-color: #c0edeb;
    }
  }
}
// .selected {
//      &.hover {
//         border: 1px solid #c0edeb;
//         width: 120px;
//         height: 40px;
//         background-color: #c0edeb;
//      }
// }
.action-menu:after {
  filter: drop-shadow(1mm 0mm 0mm rgba(0, 0, 0, 0.23));
  position: absolute;
  width: 0;
  top: 0px;
  right: 5%;
  height: 0;
  content: "";
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 10px solid #ffffff;
  filter: drop-shadow(1mm 0mm 0mm rgba(0, 0, 0, 0.23));
}

.progress-bar {
  margin-top: 20px;
  margin-bottom: 5px;
  width: 108px;
  height: 8px;
  border-radius: 4px;
  border: solid 1px #34c0be;
  background-color: #ffffff;
  position: relative;
}
.progress {
  position: absolute;
  background-color: #b2f8f7;
  width: 50%;
  border-radius: 4px;
  height: 6px;
}
.show-progress {
  padding: 7px;
  color: #5d409f;
  font-size: 12px;
}

.search-container {
  width: 300px;
  position: relative;
  max-width: 321px;
  span {
    position: absolute;
    padding: 10px;
  }
}
.search-bar {
  width: 100%;
  border: 1px solid #d6d4d4;
  border-radius: 3px;
  height: 35px;
  padding: 5px;
  outline: none;
  position: relative;
}
.search-icon {
  position: absolute;
  right: 10px;
  top: 6px;
  width: 18px;
  height: 18px;
  left: inherit;
}

img.search-icon-filter {
  position: relative;
  right: 5px;
  top: 8px;
  width: 30px;
  height: 30px;
  // margin: 38px 6px 29px 32px;
  padding: 7px 4px 6px;
}
span.filter-text {
  font-weight: 600;
  color: #34c0be;
  font-size: 14px;
}

.filter-width {
  width: 390px;
}

.show-filter-block {
  position: absolute;
  transform: translate(-5%, -12%);
  cursor: pointer;
}

.download-block {
  position: absolute;
  width: 302px;
  transform: translate(-65%, -24%);
}

.grid-list-block {
  transform: translate(0%, -12%);
}

a.anchor-underline-none {
  text-decoration: none;
}

.line {
  width: 1px;
  height: 18px;
  margin: 0px 13px 0px 1px; //41px 13px 32px 15px;
  opacity: 0.16;
  border: solid 1px #30b6bc;
}

.user-img {
  height: 33px;
}

.select-width {
  width: 300px;
  float: right;
  margin-left: 39px;
}

.select-left {
  width: 124px;
  margin: 15px 10px 15px 15px;
}

.select-right {
  width: 124px;
  margin: 15px 6px 10px 15px;
  float: right;
}

.modal-user-img {
  width: 25%;
  margin-bottom: 10px;
}

.modal-emp-name {
  width: 112px;
  height: 19px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
}

.modal-emp-code {
  width: 146px;
  height: 15px;
  // margin: 4px 121px 0 136px;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #444444;
}

.modal-emp-header {
  background-color: #ebebeb;
  padding: 25px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.modal-border-radius {
  border-radius: 8px;
}

img.close-img {
  float: right;
  cursor: pointer;
}

// tr.record-row {
//     cursor: pointer !important;
// }

.width-left-data {
  width: 400px;
  font-family: Montserrat;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: #444444;
}

.width-right-data {
  width: 400px;
  font-family: Montserrat;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #444444;
}

.hide {
  display: none;
}

.show {
  display: block;
}

img.userImg {
  width: 85px;
  height: 85px;
  border-radius: 50%;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
